export class TipoAnexoEnvio {
    dsTipoAnexo: string;
    flObrigatorio: boolean;
    flPermiteMultiplos: boolean;
    nrOrdem: number | null;
    dsTipoEdital: string | null;
    tpGrupoAnexo: string;
    dtInicioVigencia: string | null;
    dtFimVigencia: string | null;

    constructor(obj?: any) {
        this.dsTipoAnexo = obj?.dsTipoAnexo ?? '';
        this.flObrigatorio = obj?.flObrigatorio ?? false;
        this.flPermiteMultiplos = obj?.flPermiteMultiplos ?? false;
        this.nrOrdem = obj?.nrOrdem ?? null;
        this.dsTipoEdital = obj?.dsTipoEdital ?? null;
        this.tpGrupoAnexo = obj?.tpGrupoAnexo ?? '';
        this.dtInicioVigencia = obj?.dtInicioVigencia ?? null;
        this.dtFimVigencia = obj?.dtFimVigencia ?? null;
    }
}